import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import {
  payorActions,
  payorProviderCredentialsActions,
  providerActions,
  providerAssignmentActions,
} from '../../../../store';

import type { AppDispatch } from '../../../../store';

export function useLoadProviderDetails() {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();
  const { providerId } = useParams();

  useEffect(() => {
    if (!providerId) return;

    const providerRequest = dispatch(
      providerActions.getProviderById({ getAccessTokenSilently, providerId }),
    );
    dispatch(payorActions.getList({ getAccessTokenSilently }));
    const assignmentsRequest = dispatch(
      providerAssignmentActions.getList({
        provider_id: providerId,
        getAccessTokenSilently,
      }),
    );
    const credentialsRequest = dispatch(
      payorProviderCredentialsActions.getList({
        params: {
          provider_id: providerId,
        },
        getAccessTokenSilently,
      }),
    );

    return () => {
      providerRequest.abort();
      assignmentsRequest.abort();
      credentialsRequest.abort();
      dispatch(providerActions.clearLastFetchedProvider());
    };
  }, [dispatch, getAccessTokenSilently, providerId]);

  return { providerId };
}
